<app-disputes *ngIf="english"></app-disputes>
<app-disputes-hindi *ngIf="hindi"></app-disputes-hindi>